import React from 'react'
import BannerBg from './../Assets/bannerBg.png';
import { Box, Grid } from '@mui/material';
import SectionTitle from './SectionTitle';
import PartnerSlider from './Sliders/PartnerSlider';


const PartnerSection = ({ partners }) => {
    const { header_title = [], header_desc = '', sliders = [] } = partners || {};
    return (
        <Box sx={{
            backgroundImage: `url(${BannerBg})`,
            backgroundSize: { xl:'contain', xs:'cover' },
            display: 'flex',
            alignItems: 'center',
            backgroundRepeat: 'no-repeat',
            padding: '50px 0',
        }}>
            <Grid container spacing={4} sx={{ pl: 5 }}>
                <Grid item xs={12} lg={5} sx={{display: 'flex', alignItems: 'center'}}>
                    <SectionTitle variant='h3' align={'normal'} header={header_title} />
                </Grid>
                
                <Grid item xs={false}  sm={false} lg={1} />
                <Grid item xs={12} xl={5} pr={{ xs:5 }}>
                    <PartnerSlider slides={sliders} />
                </Grid>
            </Grid>
        </Box>
    )
}

export default PartnerSection